import { PendingItemDto } from '@act/shared/data-transfer-objects';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { loadPendingItems } from 'redux/slices/feedSlice';
import {
  PendingItemFilters,
  filterChoices,
  usePendingItemSelector,
} from 'redux/utils/selectors/pending-item-selectors';
import { FilterChips } from '@act/storybook';
import { FilterDiv, ScrollableStyled } from './feed-styles';
import SinglePendingItem from './single-pending-item';

export interface PendingItemsProps {
  memberId: string;
}

const PendingItems = ({ memberId }: PendingItemsProps) => {
  const [filters, setFilters] = useState<PendingItemFilters[]>([]);
  const pendingItems: PendingItemDto[] =
    usePendingItemSelector.pendingItemsForMember(memberId, filters);

  const dispatch = useDispatch();

  useEffect(() => {
    if (memberId) {
      dispatch(loadPendingItems({ userId: memberId }));
    }
  }, [memberId, dispatch]);

  return (
    <ScrollableStyled>
      <div className="scroll-content">
        <FilterDiv>
          <FilterChips
            filterChoices={filterChoices}
            setSelectedFilters={setFilters}
          />
        </FilterDiv>
        {pendingItems.map(item => (
          <SinglePendingItem
            key={`${item.externalItemType}-${item.externalItemId}`}
            item={item}
          />
        ))}
      </div>
    </ScrollableStyled>
  );
};

export default PendingItems;
